import dayjs from 'dayjs';
import { IWorkTime } from '../../interface/workTimes';

export const isWorkTimeFormChanged = (
  workTime: IWorkTime | null | undefined,
  initialWorkTime: IWorkTime | null | undefined,
  isEditMode: boolean,
): boolean => {
  if (isEditMode) {
    return (
      workTime?.matter?.id !== initialWorkTime?.matter?.id ||
      workTime?.subject !== initialWorkTime?.subject ||
      (workTime?.description || null) !== (initialWorkTime?.description || null) ||
      workTime?.workTimeType?.id !== initialWorkTime?.workTimeType?.id ||
      workTime?.activity?.id !== initialWorkTime?.activity?.id ||
      dayjs(workTime?.startTime).format('YYYY-MM-DD') !==
        dayjs(initialWorkTime?.startTime).format('YYYY-MM-DD') ||
      dayjs(workTime?.endTime).format('YYYY-MM-DD') !==
        dayjs(initialWorkTime?.endTime).format('YYYY-MM-DD')
    );
  }
  return (
    !!workTime?.matter?.id ||
    !!workTime?.subject ||
    !!workTime?.description ||
    !!workTime?.workTimeType?.id ||
    !!workTime?.activity?.id ||
    dayjs(workTime?.startTime).format('YYYY-MM-DD') !==
      dayjs(initialWorkTime?.startTime).format('YYYY-MM-DD') ||
    dayjs(workTime?.endTime).format('YYYY-MM-DD') !==
      dayjs(initialWorkTime?.endTime).format('YYYY-MM-DD')
  );
};
